type Input = {
  /** 注文時の配送先住所ID。配送のない注文はnull */
  orderShippingUniqueId: string | null;
  /** 出庫に使う配送先住所ID。出庫がない、または取得できない場合はnull */
  fulfillmentShippingUniqueId: string | null;
  isLoadingFulfillment: boolean;
  /** 出庫（配送状況）の取得に失敗したか */
  isFulfillmentError: boolean;
};

/**
 * お届け先として表示する住所の配送先住所IDを決める。
 * 購入後に住所が変わると運用が出庫の住所IDだけを最新の住所へ付け替えて発送するため、
 * 実際の発送先である出庫の住所IDを優先する。出庫がまだない注文は注文時の住所IDを使う。
 * 出庫の取得中にnullを返すのは、注文時の住所を先に取りに行って一瞬表示しないため。
 * 出庫の取得に失敗したときもnullを返す。実際の発送先が分からないので、注文時の住所で代用しない
 */
export const resolveDeliveryShippingUniqueId = (
  input: Input
): string | null => {
  const {
    orderShippingUniqueId,
    fulfillmentShippingUniqueId,
    isLoadingFulfillment,
    isFulfillmentError,
  } = input;
  if (isLoadingFulfillment || isFulfillmentError) return null;
  return fulfillmentShippingUniqueId ?? orderShippingUniqueId;
};
